// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__cWgzv","label":"CategoryService_label__29VHr","location":"CategoryService_location__3R8B_"};